import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Table, Icon, Company } from 'components/common/Elements/Elements';

import { subTableConf } from '../../helpers/configurates';
import { recordType } from 'utils/common';

import classes from './SubTable.module.scss';

const SubTable = ({ row, mouseLeave, mouseEnter, dataSub }) => {
  return (
    <Table.Row className={classes.subTable_wrap}>
      <Table.Cell className={classes.resetCell}>
        <div
          style={{ height: `calc(50px + ${dataSub.length * 66}px)` }}
          className={classes.fixCell}
        >
          <div className={classes.headerDecor} />
          <Table className={classes.subTable}>
            <Table.Header>
              <Table.Row>
                {subTableConf.map(({ field, title }, idx) => (
                  <Table.HeaderCell
                    key={field}
                    className={classes.subTable_header}
                    onMouseEnter={mouseEnter}
                    onMouseLeave={mouseLeave}
                    r={`r${idx + 10}`}
                    title={title}
                  />
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {dataSub.map((item, index) => (
                <Table.Row key={index} className={classes.subTable_row}>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r10' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <Icon
                      icon="parentLine"
                      size="73px"
                      className={cn(classes.child, classes.child_l)}
                    />
                    <Icon
                      icon="parentS"
                      size="50px"
                      className={cn(classes.child, classes.child_s)}
                    />
                    <Company
                      nameCompany={
                        item.companyName ? item.companyName : item.customerId
                      }
                      status={item.status}
                      description={item.companySize}
                      recordType={recordType(item)}
                      country={item.country}
                      domain={item.website}
                      customerId={item.customerId}
                    />
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r11' && classes.hov
                    )}
                    isId
                    onMouseEnter={mouseEnter}
                  >
                    {item.networkId}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r12' && classes.hov
                    )}
                    isId
                    onMouseEnter={mouseEnter}
                  >
                    {item.gatewayId}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r13' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {item.isTunnelExist ? 'Yes' : 'No'}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

SubTable.propTypes = {
  row: PropTypes.string,
  mouseLeave: PropTypes.func,
  mouseEnter: PropTypes.func,
  dataSub: PropTypes.array.isRequired
};

export default SubTable;
